import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import ScrollAnimation from 'src/shared/components/ScrollAnimation/ScrollAnimation';

import AboutPillarList from './components/AboutPillarList/AboutPillarList';
import styles from './AboutPanel.module.scss';

const AboutPanel = () => {
	const { t } = useTranslation();

	return (
		<Fragment>
			<ScrollAnimation animateIn="fadeInUp" animateOnce={true} offset={0}>
				<h2 className={styles.title}>{t('aboutSection.panel.title')}</h2>
				<p className={styles.text} dangerouslySetInnerHTML={{ __html: t('aboutSection.panel.description') }} />
			</ScrollAnimation>
			<AboutPillarList />
		</Fragment>
	);
};

export default AboutPanel;
